import {
  Alert,
  Card,
  Column,
  Columns,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';

import { useNotiConfig } from '../../ConfigContext.tsx';

import { FeedConfig } from './components/FeedConfig/FeedConfig.tsx';
import { MultiItemConfig } from './components/MultiItemConfig/MultiItemConfig.tsx';
import { SlackConfig } from './components/SlackConfig/SlackConfig.tsx';

import { usePermissions } from '#src/hooks/auth.tsx';

export const ConfigBody = () => {
  const { error } = useNotiConfig();

  const { isImpersonating, isInternalTestPartner } = usePermissions();

  if (error.failed) {
    return (
      <Alert tone="critical">
        <Stack space="small">
          <Text>We couldn’t load your configuration settings.</Text>
          <Text size="small">{error.message}</Text>
        </Stack>
      </Alert>
    );
  }

  return (
    <Stack space="medium">
      <Columns space="medium" collapseBelow="desktop">
        <Column>
          <Card height="full">
            <Stack space="medium">
              <Heading level="4">Email</Heading>
              <MultiItemConfig
                itemKey="emailAddresses"
                newFormTitle="New email"
              />
            </Stack>
          </Card>
        </Column>

        <Column>
          <Card height="full">
            <Stack space="medium">
              <Heading level="4">SMS</Heading>
              <MultiItemConfig
                itemKey="phoneNumbers"
                newFormTitle="New phone number"
              />
            </Stack>
          </Card>
        </Column>

        {/* TODO: support custom channels/workspaces and enable externally */}
        {isImpersonating || isInternalTestPartner ? (
          <Column>
            <Card height="full">
              <Stack space="medium">
                <Heading level="4">Slack</Heading>
                <SlackConfig id="C03R4BX5VUK" name="partner-alerts" />
              </Stack>
            </Card>
          </Column>
        ) : null}
      </Columns>

      <FeedConfig />
    </Stack>
  );
};
